"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MP = exports.transcode = exports.archive = exports.flow = exports.live = exports.job = exports.file = exports.upload = exports.image = exports.MediaType = exports.QualityRange = exports.Destination = exports.Source = exports.Image = exports.MediaPlatform = exports.Configuration = void 0;
var image_1 = require("./image/image");
Object.defineProperty(exports, "Image", { enumerable: true, get: function () { return image_1.Image; } });
var destination_1 = require("./platform/management/job/destination");
Object.defineProperty(exports, "Destination", { enumerable: true, get: function () { return destination_1.Destination; } });
var extract_poster_specification_1 = require("./platform/management/job/extract-poster-specification");
var extract_storyboard_specification_1 = require("./platform/management/job/extract-storyboard-specification");
var image_operation_specification_1 = require("./platform/management/job/image-operation-specification");
var quality_range_1 = require("./platform/management/job/quality-range");
Object.defineProperty(exports, "QualityRange", { enumerable: true, get: function () { return quality_range_1.QualityRange; } });
var source_1 = require("./platform/management/job/source");
Object.defineProperty(exports, "Source", { enumerable: true, get: function () { return source_1.Source; } });
var transcode_specification_1 = require("./platform/management/job/transcode-specification");
var flow_1 = require("./platform/management/metadata/flow");
var flow_component_1 = require("./platform/management/metadata/flow-component");
var invocation_1 = require("./platform/management/metadata/invocation");
var live_stream_1 = require("./platform/management/metadata/live-stream");
var create_archive_request_1 = require("./platform/management/requests/create-archive-request");
var create_flow_request_1 = require("./platform/management/requests/create-flow-request");
var extract_archive_request_1 = require("./platform/management/requests/extract-archive-request");
var extract_poster_request_1 = require("./platform/management/requests/extract-poster-request");
var extract_storyboard_request_1 = require("./platform/management/requests/extract-storyboard-request");
var image_operation_request_1 = require("./platform/management/requests/image-operation-request");
var import_file_request_1 = require("./platform/management/requests/import-file-request");
var copy_file_request_1 = require("./platform/management/requests/copy-file-request");
var list_files_request_1 = require("./platform/management/requests/list-files-request");
var live_stream_list_request_1 = require("./platform/management/requests/live-stream-list-request");
var live_stream_request_1 = require("./platform/management/requests/live-stream-request");
var search_jobs_request_1 = require("./platform/management/requests/search-jobs-request");
var transcode_request_1 = require("./platform/management/requests/transcode-request");
var upload_file_request_1 = require("./platform/management/requests/upload-file-request");
var configuration_1 = require("./public/platform/configuration/configuration");
Object.defineProperty(exports, "Configuration", { enumerable: true, get: function () { return configuration_1.Configuration; } });
var media_platform_1 = require("./public/platform/media-platform");
Object.defineProperty(exports, "MediaPlatform", { enumerable: true, get: function () { return media_platform_1.MediaPlatform; } });
var upload_configuration_request_1 = require("./platform/management/requests/upload-configuration-request");
var upload_job_1 = require("./public/platform/uploader/upload-job");
var media_platform_2 = require("./types/media-platform/media-platform");
Object.defineProperty(exports, "MediaType", { enumerable: true, get: function () { return media_platform_2.MediaType; } });
exports.image = {
    Image: image_1.Image,
    ImageOperationSpecification: image_operation_specification_1.ImageOperationSpecification,
    ImageOperationRequest: image_operation_request_1.ImageOperationRequest,
};
exports.upload = {
    UploadJob: upload_job_1.UploadJob,
};
exports.file = {
    UploadConfigurationRequest: upload_configuration_request_1.UploadConfigurationRequest,
    UploadFileRequest: upload_file_request_1.UploadFileRequest,
    ImportFileRequest: import_file_request_1.ImportFileRequest,
    CopyFileRequest: copy_file_request_1.CopyFileRequest,
    ListFilesRequest: list_files_request_1.ListFilesRequest,
    Source: source_1.Source,
    Destination: destination_1.Destination,
};
exports.job = {
    SearchJobsRequest: search_jobs_request_1.SearchJobsRequest,
};
exports.live = {
    LivestreamRequest: live_stream_request_1.LiveStreamRequest,
    LiveStreamListRequest: live_stream_list_request_1.LiveStreamListRequest,
    LiveStream: live_stream_1.LiveStream,
};
exports.flow = {
    CreateFlowRequest: create_flow_request_1.CreateFlowRequest,
    Flow: flow_1.Flow,
    Invocation: invocation_1.Invocation,
    FlowComponent: flow_component_1.FlowComponent,
};
exports.archive = {
    CreateArchiveRequest: create_archive_request_1.CreateArchiveRequest,
    ExtractArchiveRequest: extract_archive_request_1.ExtractArchiveRequest,
};
exports.transcode = {
    TranscodeRequest: transcode_request_1.TranscodeRequest,
    TranscodeSpecification: transcode_specification_1.TranscodeSpecification,
    ExtractPosterRequest: extract_poster_request_1.ExtractPosterRequest,
    ExtractStoryboardRequest: extract_storyboard_request_1.ExtractStoryboardRequest,
    ExtractPosterSpecification: extract_poster_specification_1.ExtractPosterSpecification,
    ExtractStoryboardSpecification: extract_storyboard_specification_1.ExtractStoryboardSpecification,
    QualityRange: quality_range_1.QualityRange,
};
exports.MP = {
    Configuration: configuration_1.Configuration,
    MediaPlatform: media_platform_1.MediaPlatform,
    Image: image_1.Image,
    image: exports.image,
    upload: exports.upload,
    file: exports.file,
    job: exports.job,
    live: exports.live,
    flow: exports.flow,
    archive: exports.archive,
    transcode: exports.transcode,
    Source: source_1.Source,
    Destination: destination_1.Destination,
    QualityRange: quality_range_1.QualityRange,
    MediaType: media_platform_2.MediaType,
};
//# sourceMappingURL=browser.js.map